import { Grid } from "~/components/layout/grid/Grid";
import { GridItem } from "~/components/layout/grid/GridItem";
import { GridSection } from "~/components/layout/grid/GridSection";
import { Icon } from "~/components/common/Icon";
import { useLocation } from "react-router";
import classNames from "classnames";
import { hubPages } from "~/services/routing/hubPages";

export type Breadcrumb = {
  url: string;
  title?: string;
};

type BreadcrumbsProps = {
  readonly breadcrumbs: Breadcrumb[];
  readonly ariaLabel?: string;
  readonly linkLabel?: string;
};

export default function Breadcrumbs({
  ariaLabel,
  breadcrumbs,
  linkLabel,
}: BreadcrumbsProps) {
  const { pathname } = useLocation();
  const validBreadcrumbs = breadcrumbs?.filter(
    (breadcrumb) => breadcrumb.title !== undefined,
  );
  if (validBreadcrumbs.length === 0) return null;
  const isHubPage = hubPages.some((hubPage) => hubPage === pathname);

  return (
    <GridSection
      className={classNames({
        "bg-kern-darkblue-050": isHubPage,
        "bg-kern-neutral-050": !isHubPage,
      })}
    >
      <Grid>
        <GridItem
          smColumn={{ start: 1, span: 12 }}
          mdColumn={{ start: 1, span: 12 }}
          lgColumn={{ start: 1, span: 12 }}
          xlColumn={{ start: 1, span: 12 }}
        >
          <nav
            className={`py-kern-space-default flex flex-wrap items-center align-center gap-kern-space-x-small`}
            aria-label={ariaLabel}
          >
            {/* Note: can't use <Link> or <NavLink> as we require fresh data from the root loader */}
            <a href="/" aria-label={linkLabel} className="kern-link p-0!">
              <Icon
                name="home"
                className="fill-kern-action-default!"
                title="Startseite"
              />
            </a>
            {validBreadcrumbs.map((breadcrumb, idx, arr) => (
              <div
                key={breadcrumb.title}
                className="kern-body-small flex items-center"
              >
                <Icon
                  name="chevron-right"
                  className="fill-kern-layout-text-muted!"
                />
                {idx === arr.length - 1 ? (
                  <span className="text-kern-layout-text-default kern-body kern-body--small p-0!">
                    {breadcrumb.title}
                  </span>
                ) : (
                  <a
                    href={breadcrumb.url ?? ""}
                    className="increase-tap-area kern-link text-kern-static-small! p-0!"
                  >
                    {breadcrumb.title ?? ""}
                  </a>
                )}
              </div>
            ))}
          </nav>
        </GridItem>
      </Grid>
    </GridSection>
  );
}
